import { ReactNode } from 'react';
import S from './PlanSpacesSection.module.scss';
export const PlanSpacesSection = (props: SubscribedSpaceSectionProps) => {
  const {
    title,
    children
  } = props;
  return <section className={S.section} data-sentry-component="PlanSpacesSection" data-sentry-source-file="PlanSpacesSection.tsx">
      <header className={S.header}>
        <h2 className={S.title}>{title}</h2>
      </header>

      <div className="mt-[30px] flex flex-col gap-[28px]">{children}</div>
    </section>;
};
type SubscribedSpaceSectionProps = {
  title: string;
  children: ReactNode;
};